/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Delete_TitleInputs */

const en_knp_guide_delete_title = /** @type {(inputs: Knp_Guide_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete KNP Guide?`)
};

const fr_knp_guide_delete_title = /** @type {(inputs: Knp_Guide_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer le guide KNP ?`)
};

const de_knp_guide_delete_title = /** @type {(inputs: Knp_Guide_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP-Leitfaden löschen?`)
};

const it_knp_guide_delete_title = /** @type {(inputs: Knp_Guide_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuoi eliminare la guida KNP?`)
};

const ru_knp_guide_delete_title = /** @type {(inputs: Knp_Guide_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить путеводитель по КНП?`)
};

const es_knp_guide_delete_title = /** @type {(inputs: Knp_Guide_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Eliminar la Guía KNP?`)
};

const zh_cn2_knp_guide_delete_title = /** @type {(inputs: Knp_Guide_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除KNP指南？`)
};

const ja_knp_guide_delete_title = /** @type {(inputs: Knp_Guide_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNPガイドを削除しますか?`)
};

const hi_knp_guide_delete_title = /** @type {(inputs: Knp_Guide_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केएनपी गाइड को हटा दें?`)
};

const pt_pt2_knp_guide_delete_title = /** @type {(inputs: Knp_Guide_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir o Guia do Parque Nacional Kruger?`)
};

/**
* | output |
* | --- |
* | "Delete KNP Guide?" |
*
* @param {Knp_Guide_Delete_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_delete_title = /** @type {((inputs?: Knp_Guide_Delete_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Delete_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_guide_delete_title(inputs)
	if (locale === "de") return de_knp_guide_delete_title(inputs)
	if (locale === "it") return it_knp_guide_delete_title(inputs)
	if (locale === "ru") return ru_knp_guide_delete_title(inputs)
	if (locale === "es") return es_knp_guide_delete_title(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_guide_delete_title(inputs)
	if (locale === "ja") return ja_knp_guide_delete_title(inputs)
	if (locale === "hi") return hi_knp_guide_delete_title(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_guide_delete_title(inputs)
	return en_knp_guide_delete_title(inputs)
});